import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './promoPopup.css';

export interface IPromoPopupProps {
  isOpen: boolean;
  onClose(): void;
  title: string;
}

export function PromoPopup({ isOpen, onClose, children, title }: React.PropsWithChildren<IPromoPopupProps>) {
  return (
    <ModalWindow open={isOpen} onClose={onClose} title={title}>
      {children}
      <div className={styles['close']} onClick={onClose}>
        <IconActionClose16 />
      </div>
    </ModalWindow>
  );
}
